export default __webpack_public_path__ + "static/media/isotype.7567ffde.svg";